import { DeleteButton, EditButton } from '@pankod/refine-antd';
import { Space, Table, TableProps } from 'antd';
import CustomTableWithPagination from 'components/table/custom-table';
import React, { useMemo, useState } from 'react';

interface TableWithActionsProps {
  columns: any[];
  data: any[];
  onEdit: (record: any) => void;
  onDelete: (key: string) => void;
}

const TableWithActions: React.FC<TableWithActionsProps> = ({ columns, data, onEdit, onDelete }) => {
  const [page, setPage] = useState<number>(1);
  const [limit, setLimit] = useState<number>(10);

  // Calculate paginated data
  const paginatedData = useMemo(
    () => data.slice((page - 1) * limit, page * limit),
    [data, page, limit]
  );

  const onTableChange: TableProps<any>['onChange'] = async (pagination) => {
    const currentPage = pagination.current ?? 1;
    const pageSize = pagination.pageSize ?? 10;
    setPage(currentPage);
    setLimit(pageSize);
  };

  const enhancedColumns = [
    ...columns,
    {
      title: 'Action',
      key: 'action',
      render: (_: any, record: any) => (
        <Space>
          <EditButton
            size="small"
            hideText
            onClick={() => {
              onEdit(record); // Trigger onEdit with the current record
            }}
          >
            Edit
          </EditButton>
          <DeleteButton
            size="small"
            hideText
            style={{ color: 'red' }}
            onClick={() => {
              onDelete(record.key); // Trigger onDelete with the record key
            }}
          >
            Delete
          </DeleteButton>
        </Space>
      ),
    },
  ];

  return (
    <CustomTableWithPagination
      total={data.length || 0}
      page={page}
      limit={limit}
      onPageChange={(page, pageSize) => {
        setPage(page);
        setLimit(pageSize);
      }}
    >
      <Table
        columns={enhancedColumns}
        pagination={false}
        scroll={{ x: true }}
        onChange={onTableChange}
        dataSource={paginatedData}
      />
    </CustomTableWithPagination>
  );
};

export default TableWithActions;
